"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressSection = void 0;
const react_1 = __importStar(require("react"));
const WebformFieldRouter_1 = require("../WebformFieldRouter");
const AddressSection = ({ section, data, errors, onChange, disabled, lookups, }) => {
    const addressesData = data.addresses || [];
    const updateAddress = (0, react_1.useCallback)((addrIdx, field, value) => {
        const updated = [...addressesData];
        if (!updated[addrIdx]) {
            updated[addrIdx] = { addressType: section.addresses[addrIdx]?.addressType };
        }
        updated[addrIdx][field] = value;
        // Clear dependent fields on parent change
        if (field === 'country') {
            updated[addrIdx]['state'] = null;
            updated[addrIdx]['district'] = null;
        }
        else if (field === 'state') {
            updated[addrIdx]['district'] = null;
        }
        onChange('addresses', updated);
    }, [addressesData, section.addresses, onChange]);
    const getFilteredLookups = (0, react_1.useCallback)((addrIdx, fieldKey) => {
        if (!lookups)
            return lookups;
        const addr = addressesData[addrIdx];
        if (fieldKey === 'state' && addr?.country && lookups['states']) {
            return { ...lookups, states: lookups['states'].filter((s) => String(s.countryId) === String(addr.country)) };
        }
        if (fieldKey === 'district' && addr?.state && lookups['districts']) {
            return { ...lookups, districts: lookups['districts'].filter((d) => String(d.stateId) === String(addr.state)) };
        }
        return lookups;
    }, [lookups, addressesData]);
    const handleCopyAddress = (0, react_1.useCallback)((targetIdx, sourceType) => {
        const sourceAddr = addressesData.find((a) => a?.addressType === sourceType);
        if (!sourceAddr)
            return;
        const updated = [...addressesData];
        updated[targetIdx] = {
            ...sourceAddr,
            addressType: section.addresses[targetIdx]?.addressType,
        };
        onChange('addresses', updated);
    }, [addressesData, section.addresses, onChange]);
    return (react_1.default.createElement(react_1.default.Fragment, null, section.addresses.map((addrConfig, idx) => (react_1.default.createElement("div", { key: addrConfig.id, className: "contact-card" },
        react_1.default.createElement("div", { className: "contact-card-header" },
            react_1.default.createElement("div", { className: "contact-name" }, addrConfig.label)),
        addrConfig.copyFrom && (react_1.default.createElement("div", { className: "copy-address" },
            react_1.default.createElement("input", { type: "checkbox", id: `copy_${addrConfig.id}`, onChange: (e) => {
                    if (e.target.checked)
                        handleCopyAddress(idx, addrConfig.copyFrom);
                }, disabled: disabled }),
            react_1.default.createElement("label", { htmlFor: `copy_${addrConfig.id}` }, addrConfig.copyLabel || `Same as ${addrConfig.copyFrom}`))),
        react_1.default.createElement("div", { className: "form-row" }, addrConfig.fields.map((field) => (react_1.default.createElement("div", { key: field.key },
            react_1.default.createElement(WebformFieldRouter_1.WebformFieldRouter, { field: {
                    key: `addr_${addrConfig.id}_${field.key}`,
                    label: field.label,
                    type: field.type || 'text',
                    required: field.required,
                    lookup: field.lookup,
                    validation: field.validation,
                }, value: addressesData[idx]?.[field.key] ?? '', onChange: (_key, val) => updateAddress(idx, field.key, val), error: errors[`addresses.${idx}.${field.key}`], disabled: disabled, lookups: getFilteredLookups(idx, field.key) }))))))))));
};
exports.AddressSection = AddressSection;
